import { render, staticRenderFns } from "./overview2.vue?vue&type=template&id=7a84dc68&scoped=true"
import script from "./overview2.vue?vue&type=script&lang=js"
export * from "./overview2.vue?vue&type=script&lang=js"
import style0 from "./overview2.vue?vue&type=style&index=0&id=7a84dc68&prod&lang=less&scoped=true"
import style1 from "./overview2.vue?vue&type=style&index=1&id=7a84dc68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84dc68",
  null
  
)

export default component.exports